import { systemListApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { systemActions } from "./actions";

export function* systemSaga() {
  yield takeEveryFsa(systemActions.getSystemList.started, function* (action) {
    yield* makeAsyncApiCall(action, systemActions.getSystemList, systemListApi);
  });
}
